import { API_URL, getAuthToken, httpError } from './draftService';

// Uploaded user files (player data, final score files) reuse the draft
// endpoints: file_type switches the backend to a per-user S3 namespace, and
// the draft_name/draft_data request fields carry the file name/contents.
export const createUserFileService = (fileType, label) => {
    const save = async (username, fileName, data) => {
        const token = await getAuthToken();
        const response = await fetch(`${API_URL}/save`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify({
                user_id: username,
                draft_name: fileName,
                draft_data: data,
                file_type: fileType
            })
        });

        if (!response.ok) {
            throw await httpError(`save ${label}`, response);
        }
        return response.json();
    };

    const list = async (username) => {
        const token = await getAuthToken();
        const response = await fetch(
            `${API_URL}/list?user_id=${encodeURIComponent(username)}&file_type=${fileType}`,
            {
                headers: {
                    'Authorization': token
                }
            }
        );

        if (!response.ok) {
            throw await httpError(`list ${label}s`, response);
        }
        const body = await response.json();
        return body.drafts.map(file => ({
            name: file.draft_name,
            lastModified: file.last_modified,
            size: file.size
        }));
    };

    const load = async (username, fileName) => {
        const token = await getAuthToken();
        const response = await fetch(
            `${API_URL}/load?user_id=${encodeURIComponent(username)}&draft_name=${encodeURIComponent(fileName)}&file_type=${fileType}`,
            {
                headers: {
                    'Authorization': token
                }
            }
        );

        if (!response.ok) {
            throw await httpError(`load ${label}`, response);
        }
        const body = await response.json();
        return body.draft_data;
    };

    const remove = async (username, fileName) => {
        const token = await getAuthToken();
        const response = await fetch(`${API_URL}/delete`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify({
                user_id: username,
                draft_name: fileName,
                file_type: fileType
            })
        });

        if (!response.ok) {
            throw await httpError(`delete ${label}`, response);
        }
        return response.json();
    };

    const rename = async (username, oldName, newName) => {
        const token = await getAuthToken();
        const response = await fetch(`${API_URL}/rename`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify({
                user_id: username,
                old_name: oldName,
                new_name: newName,
                file_type: fileType
            })
        });

        if (response.status === 409) {
            throw new Error('A file with the new name already exists');
        }
        if (!response.ok) {
            throw await httpError(`rename ${label}`, response);
        }
        return response.json();
    };

    return { save, list, load, remove, rename };
};
